import { Injectable } from '@angular/core';
import { Endpoint, LocalStorageKey } from '../../models/enums';
import { User } from '../../models/user';
import { CommonService } from '../common/common.service';
import { HttpService } from '../http/http.service';

@Injectable()
export class LogoutService {

    constructor(private httpService: HttpService, private commonService: CommonService) {
    }

    logout(userInfo: User): void {
        if (userInfo) {
            this.httpService.post(Endpoint.userManager_logoutUser, { userName: userInfo.name, organizationName: userInfo.customerName, deviceID: userInfo.deviceId }).then((userLogoutResponse: any) => {
                if (this.commonService.isTPAuthEnabledSystem) {
                    if (!localStorage.getItem(LocalStorageKey.IsTpAuthRedirect)) {
                        localStorage.setItem(LocalStorageKey.IsTpAuthRedirect, 'logoutRedirect');
                    }
                    if (userLogoutResponse?.tpAuthLogoutUrl) {
                        window.open(userLogoutResponse.tpAuthLogoutUrl, '_self');
                    } else {
                        console.warn('Error on tpauth logout -> No logout url was sent by logout api');
                        this.commonService.navigateToLoginAndNotifyChildWindows();
                    }
                    localStorage.removeItem(LocalStorageKey.IsTpAuthRedirect);
                } else {
                    this.proceedWithUiLogout();
                }
            });
        }
    }

    logoutOnAllDevices(userInfo: User): void {
        if (userInfo) {
            this.httpService.post(Endpoint.userManager_logoutUser, { userName: userInfo.name, organizationName: userInfo.customerName }).then(() => {
                if ((userInfo.handle || userInfo.loginUsername) === this.commonService.currentUser?.loginUsername && !this.commonService.isExternalApp) {
                    this.proceedWithUiLogout(true);
                }
            });
        }
    }

    proceedWithUiLogout(isLogoutFromAllDevices = false): void {
        this.clearCurrentLoginSessionData();
        if (isLogoutFromAllDevices) {
            this.commonService.clearRememberMeDataFromLocalStorage();
            this.commonService.reloadAppAndShowLoginWithMessage();
        } else {
            this.commonService.navigateToLoginAndNotifyChildWindows();
        }
    }

    handleSessionExpired(): void {
        this.clearCurrentLoginSessionData();
        this.commonService.navigateToLoginAndNotifyChildWindows();
    }

    private clearCurrentLoginSessionData(): void {
        this.commonService.clearData();
        this.httpService.stopPoller();
        this.httpService.stopSystemStatusPoller();
    }
}
